import { ThirdPartyRepository } from "../../../domain/repositories/thirdparty.repository";
import { GetIpLocationUseCase } from "../../../domain/usecases/thirdparty/get-ip-location.usecase";
import { GetIpUseCase } from "../../../domain/usecases/thirdparty/get-ip.usecase";


const getIpUseCaseFactory = 
(ip: ThirdPartyRepository) => new GetIpUseCase(ip);
export const GetIpUseCaseProvider = {
    provide: GetIpUseCase,
    useFactory: getIpUseCaseFactory,
    deps: [ThirdPartyRepository],
};

const getIpLocationUseCaseFactory = 
(location: ThirdPartyRepository) => new GetIpLocationUseCase(location);
export const GetIpLocationUseCaseProvider = {
    provide: GetIpLocationUseCase,
    useFactory: getIpLocationUseCaseFactory,
    deps: [ThirdPartyRepository],
};